module.exports = "<div class=\"notification\" ng-show=\"notification.visible\" ng-class=\"notification.classes\">\r\n    {{notification.message}}\r\n\r\n    <i class=\"icon-close_x notification-close\" ng-click=\"closeNotification()\"></i>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/common/components/notification/notification-template.html
 ** module id = 855
 ** module chunks = 2
 **/